export default __webpack_public_path__ + "static/media/hht2_ep05_timeline_q02_a.d89d2be5.png";